/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useEffect, useState } from 'react'
import Layout from '../../components/Layout/Layout'
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom'
import { RoutesLink } from "../../ApiHelper/RoutesLink";
import { apiUrl } from '../../ApiHelper/ApiUrl';
import { callApi } from '../../ApiHelper/ApiHelper';
import { scrollToTop, timeAgo } from '../../utility/CommonFunctions';
import Sanitized from '../../components/comman/Sanitized';
import Newsletter from '../../components/comman/Newsletter';
import AOS from 'aos';
import { DynamicMetaTags } from '../../components/comman/DynamicMetaTags';
import { toast } from 'react-toastify';
import BoxLoader from '../../components/Loaders/BoxLoader';

const BlogDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [state, setState] = useState({
    blogList: [],
    blogDetail: {}
  })
  const location = useLocation();
  const [metas, setMetas] = useState(null);
  const [loading, setLoading] = useState({
    blogDetails: true,
    blogLists: true
  });
  // console.log(location);


  const handleBlogList = async () => {
    const option = {
      method: 'GET',
    }
    const url = apiUrl.get_blog + "isBannerPublished=true"
    callApi(url, option).then((response) => {
      if (response?.status === true) {
        setLoading((pre) => ({
          ...pre,
          blogLists: false
        }))
        // console.log(response);
        setState((pre) => ({
          ...pre,
          blogList: response?.blogs,
        }))
      } else {
        toast.error(response?.message);
        setLoading((pre) => ({
          ...pre,
          blogLists: false
        }))
      }
    });


  }

  const handleBlogDetails = () => {
    scrollToTop();
    const option = {
      method: 'GET',
    }
    const url = apiUrl.get_blog_details + id
    callApi(url, option).then((response) => {
      if (response?.statusCode === 200) {
        setLoading((pre) => ({
          ...pre,
          blogDetails: false
        }))
        // console.log(response);
        setState((pre) => ({
          ...pre,
          blogDetail: response?.data,
        }))
        setMetas(response?.data?.metas);
      } else {
        // toast.error(response?.message);
        navigate('/blog');
        setLoading((pre) => ({
          ...pre,
          blogDetails: false
        }))
      }
    });


  }
  useEffect(() => {
    AOS.init({
      duration: 400, // Animation duration (in milliseconds)
      once: true, // Whether animation should happen only once
    });
    // setMetas(location?.state?.blogData?.metas);
    handleBlogDetails();
    handleBlogList();
  }, [id])

  return (
    <Layout>
      <DynamicMetaTags metaString={metas} />
      {/* <!-- BredCrumb-Section --> */}


      {/* <!-- Blog Details Block --> */}
      {loading.blogDetails ? <div className="col-12" >
        <BoxLoader />
      </div> : <section className="blog_detail_section mt-5 pt-5">
        <div className="container mt-5">
          <div className="blog_inner_pannel">

            <div className="section_title">
              <h2>{state?.blogDetail?.articleName}</h2>
            </div>
            <div className="main_img">
              <img src={state?.blogDetail?.bannerImage} alt={state?.blogDetail?.bannerText} />
            </div>
            <div className="info">
              <Sanitized description={state?.blogDetail?.description} />
            </div>
          </div>
        </div>
      </section>}

      {/* <!-- Story-Section-Start --> */}
      <section className="row_am latest_story" id="blog">
        {/* <!-- container start --> */}
        <div className="container">
          <div className="section_title mb-lg-5 mb-3" data-aos="fade-in" data-aos-duration="1500" data-aos-delay="100">
            <h2>MyBilty’s Latest <span>Blogs</span></h2>
            <p>Stay informed, stay ahead with MyBilty’s blog updates.</p>
          </div>
          {/* <!-- row start --> */}
          <div className="row">
            {loading.blogLists ? <div className="col-12" >
              <BoxLoader />
            </div> : state?.blogList && state?.blogList?.length > 0 && state?.blogList?.map((item, i) => i < 3 && (
              <Link to={RoutesLink.blog_detail + '/' +
                item?._id + "/" + item?.slug} state={{ blogData: item }} className="col-md-4" key={item._id}>
                <div className="story_box" data-aos="fade-up" data-aos-duration="1500">
                  <div className="story_img">
                    <img src={item?.thumbnailImage} alt="image" />
                    <span>{timeAgo(item?.createdAt)}</span>
                  </div>
                  <div className="story_text">
                    <div className='nmenewbg text-left'>
                      <h3>{item?.articleName}</h3>
                    </div>
                    <div className='namedesniew text-left'>
                      <Sanitized description={item?.description} />
                    </div>
                    <Link to={RoutesLink.blog_detail + '/' +
                      item?._id + "/" + item?.slug} state={{ blogData: item }}>READ MORE</Link>
                  </div>
                </div>
              </Link>
            ))}
            {/* <!-- story --> */}
            {/* <div className="col-md-4">
              <div className="story_box" data-aos="fade-up" data-aos-duration="1500">
                <div className="story_img">
                  <img src="/assets/images/story03.png" alt="image" />
                  <span>45 min ago</span>
                </div>
                <div className="story_text">
                  <h3>Creative ideas on app.</h3>
                  <p>Printing and typesetting industry lorem Ipsum has Lorem simply dummy text of the.</p>
                  <Link to={RoutesLink.blog_detail}>READ MORE</Link>
                </div>
              </div>
            </div> */}
          </div>
          {/* <!-- row end --> */}
        </div>
        {/* <!-- container end --> */}
      </section>
      {/* <!-- Story-Section-end --> */}


      {/* <!-- News-Letter-Section-Start --> */}
      <Newsletter />
      {/* <!-- News-Letter-Section-end --> */}

    </Layout>
  )
}

export default BlogDetail
